/**
 * Service that hooks into the collision module to provide information to the Collision debug tab
 */
class CollisionDebugService {
    setSnapshotProvider(provider) {
        this.snapshotProvider = provider;
    }
    getSnapshot() {
        var _a, _b;
        return (_b = (_a = this.snapshotProvider) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : { rooms: [] };
    }
}
export const collisionDebugService = new CollisionDebugService();
